<script lang="ts">
import { Container } from 'inversify'
import { computed, defineComponent } from 'vue'

import { StatusType } from '@collector/sportsapi-client-legacy'
import EventHeader from '@mobile/views/Relation/Shared/EventHeader/EventHeader.vue'
import Popup from '@mobile/views/Relation/Shared/Popup/Popup.vue'
import { bindSeasonParticipants } from '@mobile/views/Relation/Shared/RelationDependencies/bindSeasonParticipants'
import { bindSkins } from '@mobile/views/Relation/Shared/RelationDependencies/bindSkins'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import VerifyResults from '@mobile/views/Relation/Shared/VerifyResults/VerifyResults.vue'
import { Basketball3x3RelationIoCBindings } from '@mobile/views/Relation/Sports/Basketball3x3/BasketballRelationDependencies/Basketball3x3RelationDependencies'
import { bindActiveParticipant } from '@mobile/views/Relation/Sports/Basketball3x3/BasketballRelationDependencies/bindActiveParticipant'
import { bindAssignableIncidentConfiguration } from '@mobile/views/Relation/Sports/Basketball3x3/BasketballRelationDependencies/bindAssignableIncidentConfiguration'
import { bindEventClockConfiguration } from '@mobile/views/Relation/Sports/Basketball3x3/BasketballRelationDependencies/bindEventClockConfigration'
import { bindEventHeaderConfiguration } from '@mobile/views/Relation/Sports/Basketball3x3/BasketballRelationDependencies/bindEventHeaderConfiguration'
import { bindEventStatusesConfiguration } from '@mobile/views/Relation/Sports/Basketball3x3/BasketballRelationDependencies/bindEventStatusesConfiguration'
import { bindEventStatusesList } from '@mobile/views/Relation/Sports/Basketball3x3/BasketballRelationDependencies/bindEventStatusesList'
import { bindIncidentHandlersConfiguration } from '@mobile/views/Relation/Sports/Basketball3x3/BasketballRelationDependencies/bindIncidentHandlersConfiguration'
import { bindIncidentsConfiguration } from '@mobile/views/Relation/Sports/Basketball3x3/BasketballRelationDependencies/bindIncidentsConfiguration'
import { bindIncidentsResultConfiguration } from '@mobile/views/Relation/Sports/Basketball3x3/BasketballRelationDependencies/bindIncidentsResultConfiguration'
import { bindLineupsConfiguration } from '@mobile/views/Relation/Sports/Basketball3x3/BasketballRelationDependencies/bindLineupsConfiguration'
import { bindRelationHooks } from '@mobile/views/Relation/Sports/Basketball3x3/BasketballRelationDependencies/bindRelationHooks'
import LiveView from '@mobile/views/Relation/Sports/Basketball3x3/LiveView/LiveView.vue'

export default defineComponent({
  components: {
    VerifyResults,
    LiveView,
    Popup,
    EventHeader,
  },
  setup() {
    const { probableEvent } = useEventInjections()

    const displayVerifyResults = computed(() => {
      const probableRelationStatus = probableEvent.value?.status_type

      return probableRelationStatus === StatusType.Finished
    })

    return { displayVerifyResults }
  },
})

export function bindBasketball3x3RelationDependencies(
  ioc: Container,
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
): Record<any, any> {
  bindActiveParticipant(ioc)
  bindEventStatusesConfiguration(ioc)
  bindIncidentHandlersConfiguration(ioc)
  bindEventStatusesList(ioc)
  bindIncidentsConfiguration(ioc)
  bindIncidentsResultConfiguration(ioc)
  bindSeasonParticipants(ioc)
  bindLineupsConfiguration(ioc)
  bindAssignableIncidentConfiguration(ioc)
  bindRelationHooks(ioc)
  bindEventHeaderConfiguration(ioc)
  bindEventClockConfiguration(ioc)

  bindSkins(ioc)

  return Basketball3x3RelationIoCBindings
}
</script>

<template>
  <Popup />
  <EventHeader />
  <VerifyResults v-if="displayVerifyResults" />
  <LiveView v-else />
</template>
